module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/well/well-02slide_03.png";